import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Mail, Lock, Key, ArrowLeft, CheckCircle, ListRestart } from 'lucide-react';
import showCustomAlert from '../../Extracomponents/CustomAlert/CustomLogin';
import { ForgetClientPasswordApi, ClientResetPassword, basicsettinglist } from '../../Services/Admin/Admin';
import { image_baseurl } from '../../../Utils/config';
import $ from "jquery";


const ForgetPassword = () => {

    const theme = localStorage.getItem("theme");
    const [themeBackground, setThemeBackground] = useState("#ffffff");


    useEffect(() => {
        getsettinglist()
        if (theme) {
            try {
                const parsedTheme = JSON.parse(theme);
                const bgColor = parsedTheme?.sidebarColor || "#ffffff";
                setThemeBackground(bgColor);
            } catch (err) {
                console.error("Theme parse error", err);
            }
        }
    }, []);

    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [information, setInformation] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showResetModal, setShowResetModal] = useState(false);

    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [errors, setErrors] = useState({});

    const validateEmail = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validatePassword = (password) => {
        return password.length >= 6;
    };

    const handleSendOTP = async (e) => {
        e.preventDefault();
        setErrors({});

        if (!email) {
            setErrors({ email: 'Email is required' });
            return;
        }

        if (!validateEmail(email)) {
            setErrors({ email: 'Please enter a valid email address' });
            return;
        }

        setIsLoading(true);
        try {
            const data = { Email: email };
            const response = await ForgetClientPasswordApi(data);

            if (response?.status) {
                showCustomAlert(
                    "success",
                    `${response.message} If you don’t see the email, check your spam or junk folder.`);
                setShowResetModal(true);
                setStep(2);
            } else {
                showCustomAlert("error", response.message || "Something went wrong.", null, null);
            }

        } catch (error) {
            showCustomAlert("error", "Something went wrong!", null, null);
        } finally {
            setIsLoading(false);
        }
    };



    const handleResetPassword = async (e) => {
        e.preventDefault();
        const newErrors = {};

        if (!otp) newErrors.otp = 'OTP is required';
        if (!newPassword) newErrors.newPassword = 'New password is required';
        else if (!validatePassword(newPassword)) newErrors.newPassword = 'Password must be at least 6 characters';
        if (!confirmPassword) newErrors.confirmPassword = 'Please confirm your password';
        else if (newPassword !== confirmPassword) newErrors.confirmPassword = 'Passwords do not match';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setIsLoading(true);

        try {
            const data = { resetToken: otp, newPassword };
            const response = await ClientResetPassword(data);

            if (response?.status) {
                showCustomAlert("success", response.message, navigate, "/user-login");
            } else {
                showCustomAlert("error", response.message || "Something went wrong.", null, null);
            }

        } catch (error) {
            showCustomAlert("error", "Something went wrong!", null, null);
        } finally {
            setIsLoading(false);
        }
    };




    const getsettinglist = async () => {
        try {
            let token = "";
            const response = await basicsettinglist(token);
            if (response.status) {
                localStorage.setItem("theme", JSON.stringify(response?.Theme));

                const faviconElement = document.querySelector("link[rel='icon']");
                if (faviconElement) {
                    faviconElement.href =
                        image_baseurl + "uploads/basicsetting/" + response.data[0].favicon;

                    $(".companyName").html(response.data[0].from_name);
                } else {
                    console.log("Favicon element not found");
                }

                setInformation(response.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    };



    return (
        <>
            <link
                href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
                rel="stylesheet"
            />

            <div className="main-login min-vh-100 d-flex align-items-center justify-content-center p-4"
                style={{
                    background: themeBackground,
                    minHeight: "100vh",
                    width: "100%",
                    transition: "background 0.4s ease-in-out"
                }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-4">
                            <div className="card shadow-lg border-0 rounded-4 new-bdr">
                                <div className="card-body px-5 py-4 new-bg">
                                    <div className="text-center mb-4">
                                        <div className="d-inline-flex align-items-center justify-content-center mb-3"
                                        >
                                            <img
                                                src={`${image_baseurl}uploads/basicsetting/${information[0]?.logo}`}
                                                alt="Logo"
                                                style={{ width: '200px', }}
                                            />
                                        </div>

                                        <p className="text-light">
                                            Enter your email address  to reset your password
                                        </p>
                                    </div>

                                    <form onSubmit={handleSendOTP}>
                                        <div className="mb-4">
                                            <label htmlFor="email" className="form-label fw-semibold text-light">
                                                Email Address
                                            </label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light border-end-0">
                                                    <Mail size={20} className="text-muted" />
                                                </span>
                                                <input
                                                    id="email"
                                                    type="email"
                                                    className={`form-control border-start-0 ps-2 ${errors.email ? 'is-invalid' : ''}`}
                                                    placeholder="Enter your email address"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    style={{ fontSize: '16px', padding: '12px 16px' }}
                                                />
                                            </div>
                                            {errors.email && (
                                                <div className="invalid-feedback d-block">{errors.email}</div>
                                            )}
                                        </div>

                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-lg w-100 mb-4 fw-semibold"
                                            disabled={isLoading}
                                            style={{ padding: '12px' }}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                    Sending...
                                                </>
                                            ) : (
                                                'Submit'
                                            )}
                                        </button>

                                        <div className="text-center ">
                                            <Link
                                                to="/user-login"
                                                className="text-decoration-none text-light d-inline-flex align-items-center"
                                            >
                                                <ArrowLeft size={18} className="me-2" />
                                                Back to Login
                                            </Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {showResetModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg rounded-4">
                            <div className="modal-header border-0 pb-3">
                                <div className="d-flex align-items-center">
                                    <div className="bg-warning rounded-circle d-flex align-items-center justify-content-center me-3"
                                        style={{ width: '50px', height: '50px' }}>
                                        {/* <CheckCircle size={24} className="text-white" /> */}
                                        <CheckCircle className="text-dark" />
                                    </div>
                                    <h5 className="modal-title fw-bold text-white">Reset Your Password</h5>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close "
                                    onClick={() => setShowResetModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body p-4">
                                <form onSubmit={handleResetPassword}>
                                    <div className="mb-3">
                                        <label htmlFor="otp" className="form-label fw-semibold">
                                            Verification Code
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-end-0">
                                                <Key size={20} className="text-muted" />
                                            </span>
                                            <input
                                                id="otp"
                                                type="text"
                                                className={`form-control border-start-0 ps-0 text-center fw-bold ${errors.otp ? 'is-invalid' : ''}`}
                                                placeholder="Enter 6-digit code"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                                maxLength={6}
                                                style={{ fontSize: '18px', letterSpacing: '0.1em', padding: '12px' }}
                                            />
                                        </div>
                                        {errors.otp && (
                                            <div className="invalid-feedback d-block">{errors.otp}</div>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="newPassword" className="form-label fw-semibold">
                                            New Password
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-end-0">
                                                <Lock size={20} className="text-muted" />
                                            </span>
                                            <input
                                                id="newPassword"
                                                type={showPassword ? "text" : "password"}
                                                className={`form-control border-start-0 border-end-0 ps-2  ${errors.newPassword ? 'is-invalid' : ''}`}
                                                placeholder="Enter new password"
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                                style={{ fontSize: '16px', padding: '12px 16px' }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary "
                                                onClick={() => setShowPassword(!showPassword)}
                                                style={{
                                                    // borderTopLeftRadius: 0,
                                                    // borderBottomLeftRadius: 0,
                                                    // borderTopRightRadius: '0.375rem',
                                                    // borderBottomRightRadius: '0.375rem',
                                                    // padding: '12px 12px',
                                                    // borderLeft: 'none',
                                                    borderColor: '#dedede'
                                                }}
                                            >
                                                {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
                                            </button>
                                        </div>
                                        {errors.newPassword && (
                                            <div className="invalid-feedback d-block">{errors.newPassword}</div>
                                        )}
                                    </div>


                                    <div className="mb-4">
                                        <label htmlFor="confirmPassword" className="form-label fw-semibold">
                                            Confirm Password
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-end-0">
                                                <Lock size={20} className="text-muted" />
                                            </span>
                                            <input
                                                id="confirmPassword"
                                                type={showConfirmPassword ? "text" : "password"}
                                                className={`form-control border-start-0 border-end-0 ps-2  ${errors.confirmPassword ? 'is-invalid' : ''}`}
                                                placeholder="Confirm new password"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                style={{ fontSize: '16px', padding: '12px 16px' }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary "
                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                style={{ borderColor: '#dedede' }}
                                            >
                                                {showConfirmPassword ? <Eye size={18} /> : <EyeOff size={18} />}
                                            </button>
                                        </div>
                                        {errors.confirmPassword && (
                                            <div className="invalid-feedback d-block">{errors.confirmPassword}</div>
                                        )}
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary text-dark btn-lg w-100 fw-semibold"
                                        disabled={isLoading}
                                        style={{ padding: '12px' }}
                                    >
                                        {isLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                Resetting...
                                            </>
                                        ) : (
                                            'Reset Password'
                                        )}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ForgetPassword;
